import React, { useEffect, useState } from 'react';
import { Check, FileText, Heart, Moon, ShieldAlert, Star, Clock, AlertTriangle, BookOpen, PenTool, Map, DollarSign } from 'lucide-react';
import { Section, CTAButton } from './Shared';
import { HealingBackgroundDecor } from './HealingIcons';
import { Pricing } from './Pricing';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 8,
    s: 33
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('pendulo-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 64;
  });
  useEffect(() => {
    sessionStorage.setItem('pendulo-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-250">
      <div className="bg-brand-purple text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-purpleLight/40" data-id="element-251">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-252">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-253">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-gold/40 bg-gradient-to-br from-brand-surfaceLight/95 to-brand-goldLight/10 shadow-[0_10px_40px_rgba(56,189,248,0.12)]" data-id="element-254">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-255">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-gold shrink-0" data-id="element-256" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-plum text-center" data-id="element-257">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-258">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-259" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-260">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-261" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-262">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-263" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-brand-surface border border-brand-gold/30 rounded-xl px-4 py-3 mb-6" data-id="element-264">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-brand-gold shrink-0" data-id="element-265" />
          <p className="text-sm md:text-base font-semibold text-brand-text text-center" data-id="element-266">
            Después sube $8.000 ARS.{' '}
            <span className="text-brand-purple" data-id="element-267">No vuelve.</span>
          </p>
        </div>

        <div className="bg-brand-surfaceLight/80 rounded-2xl p-4 md:p-5 border border-brand-gold/30" data-id="element-268">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-269">
            <div className="flex items-center gap-2" data-id="element-270">
              <span className="relative flex h-2.5 w-2.5" data-id="element-271">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-gold opacity-75" data-id="element-272"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-gold" data-id="element-273"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-274">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-purple uppercase tracking-wide" data-id="element-275">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-gold/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-276">
            <div className="bg-gradient-to-r from-brand-gold to-brand-goldDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-277" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-278">
            <strong className="text-brand-purple" data-id="element-279">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const modules = [{
  phase: '🔵 FASE 1: DOMÍNALO',
  desc: 'Entendé la herramienta antes de usarla',
  items: ['Módulo 1: Qué es la Radiestesia · La Ciencia Detrás del Péndulo', 'Módulo 2: El Campo Energético Humano · Aura y Capas', 'Módulo 3: Los 7 Chakras · Diagnóstico Técnico', 'Módulo 4: El Péndulo · Calibración, Tipos y Códigos', 'Módulo 5: Las 7 Leyes Universales · El Marco Operativo']
}, {
  phase: '🟣 FASE 2: ÚSALO',
  desc: 'Estructurá tu servicio y atendé con confianza',
  items: ['Módulo 6: Protocolo Completo de Sesión Profesional', 'Módulo 7: Técnicas de Sanación con el Péndulo', 'Módulo 8: Radiestesia a Distancia · Camillas y Biómetros']
}, {
  phase: '🟡 FASE 3: MONETIZALO',
  desc: 'Convertí tu práctica en un negocio real desde casa',
  items: ['Módulo 9: Fabricación de Péndulos para Vender', 'Módulo 10: Tu Negocio desde Casa · El Modelo de Triple Ingreso', 'Módulo 11: Ética y Protección del Terapeuta']
}];
const protocolFeatures = ['✅ Explicación desde cero', '✅ Protocolo paso a paso', '✅ Errores frecuentes y cómo evitarlos', '✅ Checklist de aplicación', '✅ Ejercicios prácticos', '✅ Resumen final aplicable desde hoy'];
const bonuses = [{
  icon: FileText,
  image: 'https://cdn.magicpatterns.com/uploads/bM2yjXmfUNa82YRpf8jbJK/portada_bonus1.png',
  title: 'BONUS 1 — EL LEGAJO DE CAMPO',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-gold',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  desc: 'Pack Profesional de Fichas Imprimibles para Radiestesistas. Fichas diseñadas para registrar cada consulta, hacer seguimiento de tu cliente y proyectar imagen profesional desde el primer día.',
  result: '✅ Tu emprendimiento se ve profesional desde la primera sesión',
  price: '$12.000'
}, {
  icon: Map,
  image: 'https://cdn.magicpatterns.com/uploads/5UA5pqbd4vDFQvmAJLSZzF/portada_bonus2.png',
  title: 'BONUS 2 — ATLAS DE CAMILLAS Y BIÓMETROS',
  pages: '20 páginas · listo para imprimir',
  color: 'text-brand-purple',
  bgColor: 'bg-brand-purple/10',
  borderColor: 'border-brand-purple/30',
  desc: 'Guía visual de herramientas esenciales para radiestesistas. Mapas energéticos, biómetros y diagramas listos para usar en tus sesiones.',
  result: '✅ Trabajá con criterio y confianza desde el día uno',
  price: '$10.000'
}, {
  icon: DollarSign,
  image: 'https://cdn.magicpatterns.com/uploads/dAhogrHKrLBvSpxdYAnXx3/portadabonus3.png',
  title: 'BONUS 3 — TUS PRIMEROS INGRESOS CON EL PÉNDULO',
  pages: '30 páginas · listo para imprimir',
  color: 'text-brand-forest',
  bgColor: 'bg-brand-forest/10',
  borderColor: 'border-brand-forest/30',
  desc: 'El camino más corto entre aprender y cobrar. Cuánto cobrar, cómo presentar tu servicio, cómo conseguir tus primeros clientes sin gastar en publicidad.',
  result: '✅ Del aprendizaje al primer ingreso real en el menor tiempo posible',
  price: '$8.000'
}];
const planComparison = [{
  situation: 'Querés un ingreso extra además de las consultas',
  without: 'Solo ganás cuando atendés',
  with: 'Fabricás péndulos y los vendés sin dar tu tiempo'
}, {
  situation: 'Un cliente te pide dónde comprar un péndulo',
  without: 'Lo mandás a otro',
  with: 'Se lo vendés vos y cobrás por eso'
}, {
  situation: 'Querés diferenciarte desde el día uno',
  without: 'Sos uno más que da consultas',
  with: 'Tenés consultas Y productos artesanales propios'
}, {
  situation: 'Querés escalar tu emprendimiento',
  without: 'Tu techo es tu tiempo disponible',
  with: 'Sumás una línea de productos sin límite de escala'
}, {
  situation: 'Querés dos fuentes de ingreso desde casa',
  without: 'Una sola fuente de ingreso',
  with: 'Consultas + venta de péndulos artesanales'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-280">
      <HealingBackgroundDecor data-id="element-281" />

      <div className="text-center mb-12" data-id="element-282">
        <div className="inline-flex items-center space-x-2 bg-brand-surfaceLight border border-brand-gold/40 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-283">
          <span className="text-xl" data-id="element-284">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-purple text-sm md:text-base" data-id="element-285">
            EL MÉTODO PÉNDULO™
          </span>
        </div>
        <h2 className="text-2xl md:text-5xl font-display font-bold mb-4 leading-tight text-brand-plum" data-id="element-286">
          1 Tomo Principal + 3 Bonus
        </h2>
        <p className="text-brand-text/70 text-base md:text-lg" data-id="element-287">
          125 páginas — Todo resuelto.
        </p>
      </div>

      {/* Tomo Principal block */}
      <div className="max-w-4xl mx-auto mb-12" data-id="element-288">
        <div className="rounded-2xl p-6 md:p-8 border bg-brand-purple/5 border-brand-purple/25 backdrop-blur-sm shadow-sm mb-6" data-id="element-289">
          <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6" data-id="element-290">
            <div className="shrink-0 mx-auto md:mx-0 w-48 md:w-64" data-id="element-291">
              <img src="https://cdn.magicpatterns.com/uploads/6THaDxcjaZDisnGux7Xzqx/portada_tomo1.png" alt="Portada Tomo 1 — El Método Péndulo" className="w-full h-auto rounded-md shadow-lg ring-1 ring-brand-purple/15" draggable={false} data-id="element-292" />
            </div>
            <div className="flex-grow" data-id="element-293">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-plum" data-id="element-294">
                📘 TOMO PRINCIPAL — LA GUÍA MAESTRA DEL PÉNDULO
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-295">
                De cero a tu primer ingreso con la radiestesia · 45 páginas
              </p>
              <p className="text-brand-text/80 text-sm mb-4" data-id="element-296">
                El manual central de tu emprendimiento. Aprendés a usar el
                péndulo desde cero, a estructurar consultas profesionales y a
                generar tus primeros ingresos reales — sin experiencia previa,
                sin consultorio y sin inversión inicial.
              </p>

              {/* Protocols list */}
              <div className="bg-brand-surfaceLight/80 p-4 rounded-lg border border-brand-purple/15 mb-4 space-y-4" data-id="element-297">
                {modules.map((phase, i) => <div key={i} data-id="element-298">
                    <p className="text-xs font-bold uppercase tracking-wider text-brand-purple mb-1" data-id="element-299">
                      {phase.phase}
                    </p>
                    <p className="text-[11px] text-brand-text/60 mb-2 italic" data-id="element-300">
                      {phase.desc}
                    </p>
                    <div className="space-y-1.5 text-xs md:text-sm text-brand-text/85" data-id="element-301">
                      {phase.items.map((item, j) => <div key={j} className="flex items-start" data-id="element-302">
                          <span className="text-brand-gold mr-2 shrink-0" data-id="element-303">
                            ·
                          </span>
                          <span data-id="element-304">{item}</span>
                        </div>)}
                    </div>
                  </div>)}
                <div className="pt-2 border-t border-brand-purple/10" data-id="element-305">
                  <p className="text-xs font-bold uppercase tracking-wider text-brand-purple mb-1" data-id="element-306">
                    📎 APÉNDICE
                  </p>
                  <div className="flex items-start text-xs md:text-sm text-brand-text/85" data-id="element-307">
                    <span className="text-brand-gold mr-2 shrink-0" data-id="element-308">·</span>
                    <span data-id="element-309">Ficha del Paciente y Glosario Técnico</span>
                  </div>
                </div>
              </div>

              {/* Per-protocol features */}
              <div className="bg-brand-surfaceLight/80 p-4 rounded-lg border border-brand-purple/15" data-id="element-310">
                <p className="text-xs font-bold uppercase tracking-wider text-brand-purple mb-3" data-id="element-311">
                  Cada módulo incluye
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-1.5 text-xs md:text-sm text-brand-text/85" data-id="element-312">
                  {protocolFeatures.map((f, i) => <div key={i} className="flex items-center" data-id="element-313">
                      <span data-id="element-314">{f}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-315">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-brand-plum" data-id="element-316">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-gold mt-1 font-bold" data-id="element-317">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-318">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-gold/30 relative overflow-hidden bg-brand-surfaceLight/90 flex flex-col" data-id="element-319">
                <div className={`absolute top-3 left-3 ${bonus.bgColor} border ${bonus.borderColor} ${bonus.color} text-[11px] font-mono font-bold px-2 py-0.5 rounded-md`} data-id="element-320">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-321">
                  GRATIS
                </div>
                {bonus.image ? <div className="mt-6 mb-3 w-20 h-28 rounded-md overflow-hidden ring-1 ring-brand-gold/30 shadow-md bg-brand-dark/40" data-id="element-322">
                    <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" draggable={false} data-id="element-323" />
                  </div> : <Icon className={`w-7 h-7 ${bonus.color} mb-3 mt-6`} data-id="element-324" />}
                <h4 className="text-base md:text-lg font-serif font-bold mb-2 pr-14 leading-tight text-brand-text" data-id="element-325">
                  {bonus.title}
                </h4>
                <p className={`${bonus.color} text-xs font-medium mb-3`} data-id="element-326">
                  {bonus.pages}
                </p>
                <p className="text-brand-text/80 mb-3 text-xs md:text-sm flex-grow" data-id="element-327">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-purple mb-2" data-id="element-328">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-329">
                  <span className="line-through" data-id="element-330">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-gold" data-id="element-331">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-8" data-id="element-332">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-gold/30 bg-brand-surfaceLight/80" data-id="element-333">
            <p className="text-sm md:text-base font-medium text-brand-text/80" data-id="element-334">
              💰 Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-335">$30.000</span>{' '}
              <span className="text-brand-purple font-bold" data-id="element-336">
                → GRATIS con tu Kit Péndulo
              </span>
            </p>
          </div>
        </div>
      </div>

      <LaunchUrgency data-id="element-337" />

      <Pricing data-id="element-338" />

      {/* Kit Fabricante Pro — comparison */}
      <div className="max-w-4xl mx-auto mb-12 mt-12" data-id="element-339">
        <div className="bg-brand-surfaceLight rounded-2xl p-5 md:p-6 border border-brand-gold/30 shadow-sm" data-id="element-340">
          <p className="text-base md:text-lg font-semibold text-brand-plum mb-4 text-center" data-id="element-341">
            🎓 ¿Qué agrega el Kit Fabricante Pro?
          </p>

          <div className="hidden md:block" data-id="element-342">
            <div className="grid grid-cols-3 gap-2 text-[11px] font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-gold/20 pb-2 mb-2" data-id="element-343">
              <div data-id="element-344">Situación</div>
              <div className="text-brand-burgundy" data-id="element-345">❌ Sin Kit Fabricante</div>
              <div className="text-brand-purple" data-id="element-346">✅ Con Kit Fabricante</div>
            </div>
            <div className="space-y-2" data-id="element-347">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-2 text-xs text-brand-text/80 py-1.5 border-b border-brand-gold/10 last:border-0" data-id="element-348">
                  <div className="font-medium" data-id="element-349">{row.situation}</div>
                  <div className="text-brand-burgundy/80" data-id="element-350">{row.without}</div>
                  <div className="text-brand-purple font-medium" data-id="element-351">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-3" data-id="element-352">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-gold/15 pb-3 last:border-0 last:pb-0" data-id="element-353">
                <p className="text-xs font-semibold text-brand-text mb-1.5" data-id="element-354">
                  {row.situation}
                </p>
                <div className="text-[11px] text-brand-burgundy/80 mb-0.5" data-id="element-355">
                  ❌ {row.without}
                </div>
                <div className="text-[11px] text-brand-purple font-medium" data-id="element-356">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm font-medium text-brand-goldDark italic text-center mt-5" data-id="element-357">
            Un solo péndulo vendido con esta guía ya paga la diferencia de
            precio.
          </p>
        </div>
      </div>
    </Section>;
};